/** The words and numbers the app's billing lines share: the studio's live hours note and an upload's receipt. */
import { money } from "../../shared/plans";
import { inApp } from "../lib/inApp";

/** Hours or people, with one decimal only when there is one: "1,250", "9.5". */
export function amount(n: number): string {
  return n.toLocaleString("en-US", { maximumFractionDigits: 1 });
}

/**
 * "10 hours of new video added for $39.": the receipt under an upload that needed a top-up. Inside the
 * phone app no price is shown (flashsuite-phone docs/APP-MODE.md section 2), so it ends at "added."
 */
export function uploadReceipt(topup: { hours: number; amount_cents: number; currency: string }): string {
  const added = `${amount(topup.hours)} hours of new video added`;
  return inApp() ? `${added}.` : `${added} for ${money(topup.amount_cents, topup.currency)}.`;
}
